<template>
  <button
    type="button"
    class="inline-flex min-h-6 items-center gap-1 rounded-md bg-fill-brand-secondary px-1.5 py-0.5 align-baseline text-[13px] font-semibold leading-4 text-text-brand underline underline-offset-2 transition-colors hover:bg-fill-brand-secondary-hover focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brand-primary"
    @click.stop.prevent="onActivate"
    @keydown.enter.stop
    @keydown.space.stop
    @keyup.enter.stop
    @keyup.space.stop
  >
    <Icon
      v-if="!hasPermission"
      icon="mdi:lock"
      class="size-3.5 shrink-0"
      aria-hidden="true"
    />
    <span>{{ $t("channel.chat.contestLink.enterContest") }}</span>
  </button>
</template>

<script setup lang="ts">
import { Icon } from "@iconify/vue";
import { ChannelPermission } from "@f3/shared/permissions";
import { useGatingForAction } from "@/features/gating/evaluation/use-gating-for-action";
import { navigateTo } from "@/utils/app-navigator";

const props = defineProps<{
  href: string;
}>();

const { hasPermission, handler } = useGatingForAction<[Event]>(
  ChannelPermission.raffleJoin,
  (event) => {
    event.preventDefault();
    event.stopPropagation();
    void navigateTo(props.href);
  },
);

function onActivate(event: Event) {
  handler(event);
}
</script>
